import { ADD_CALENDAR_YEAR } from './../../action-types/bookproperties';

export const STATE_KEY = 'calendarStartYear';

export const calendarStartYear = (state = 0, action) => {
  switch (action.type) {
    case ADD_CALENDAR_YEAR: {
      return action.year;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/calendarYear.js